import React from 'react';
import { useContent } from '../cms/content.js';

export default function Connections() {
  const cms = useContent();
  return (
    <section
      style={{
        position: 'relative',
        zIndex: 10,
        background: '#0a0a0b',
        borderTop: '1px solid rgba(201,168,106,0.14)',
        padding: '130px 32px'
      }}
    >
      <div style={{ maxWidth: '1180px', margin: '0 auto' }}>
        <div data-reveal="" style={{ textAlign: 'center', marginBottom: '62px' }}>
          <div
            style={{
              font: "500 12px/1 'JetBrains Mono',monospace",
              letterSpacing: '0.34em',
              textTransform: 'uppercase',
              color: '#c9a86a',
              marginBottom: '24px'
            }}
          >
            {cms.connections.eyebrow}
          </div>
          <h2
            style={{
              margin: '0 auto',
              fontFamily: "'Cormorant',serif",
              fontWeight: 400,
              fontSize: 'clamp(38px,5vw,68px)',
              lineHeight: '1.0',
              color: '#f5f0e6'
            }}
          >
            {cms.connections.heading}
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '18px' }}>
          {(cms.connections.cards || []).map((card, index) => (
            <div
              key={index}
              data-reveal=""
              className="kny-card kny-photo"
              style={{ border: '1px solid rgba(201,168,106,0.16)', background: '#0c0d10' }}
            >
              <image-slot
                id={index === 0 ? 'kny-office' : 'kny-residence'}
                className="kny-img"
                src={card.image}
                shape="rect"
                placeholder={card.placeholder}
                style={{ display: 'block', width: '100%', height: '300px' }}
              />
              <div style={{ padding: '32px 34px' }}>
                <div
                  style={{
                    font: "500 11px/1 'JetBrains Mono',monospace",
                    letterSpacing: '0.2em',
                    textTransform: 'uppercase',
                    color: '#c9a86a',
                    marginBottom: '16px'
                  }}
                >
                  {card.label}
                </div>
                <p
                  style={{
                    margin: '0 0 22px',
                    fontSize: '15px',
                    lineHeight: 1.62,
                    fontWeight: 300,
                    color: '#9b958a'
                  }}
                >
                  {card.body}
                </p>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    borderTop: '1px solid rgba(201,168,106,0.14)',
                    paddingTop: '20px',
                    font: "500 12px/1 'JetBrains Mono',monospace",
                    color: '#8b8579'
                  }}
                >
                  {(card.rows || []).map((row, rIdx) => (
                    <div key={rIdx} style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span>{row.label}</span>
                      <span style={{ color: '#ece7dd' }}>{row.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
